import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        _liffId:window.location.search.split('liffid=')[1].split('&keyword=')[0] || 'noLiffId',
        keyword: window.location.search.split('keyword=')[1].split('&c')[0] || 'noKeyword',
        channelId: window.location.search.split('&c=')[1].split('&description=')[0] || `noChannelID`, //ChannelID
        ShareDescription: window.location.search.split('&description=')[1] || `noChannelID`, //ChannelID
        UserCheck: null,
        userId: null, //USID
        Uid: null, //basicID
        recUserID: window.location.search.split('&rec=')[1]|| `noRecUserID`,
        bgcolor: null,
        displayname: null,
        picture: null,
        point: '0',
        level: '0',
        level_name: null,
        share: '0',
        basicid: null
    },
    actions: {
        bgColor(state, color) {
            state.commit('bgColor', color)
        },
        getkeyword(state, key) {
            state.commit('getkeyword', key)
        },
        getUserid(state, myliffId){
            //console.log(`====1113:${myliffId}====`)
            liff.init({
                liffId: myliffId
            }).then(()=>{
                //console.log('====111====')
                liff.getProfile().then((profile) => {
                    //alert("pro:" + JSON.stringify(profile))
                    let name = profile.displayName
                    let img = profile.pictureUrl
                    let userId = profile.userId
                    //console.log(`====${name}${userId}====`)
                    state.commit('getUserPro', {
                        displayName: name,
                        picture: img,
                        userid: userId
                    })
                })
            }).catch((err) => {

            })
        },
        // 使用liff 獲取使用者資料
        /*getUserid(state, user){
            liff.init(function (data) {
                let userid = data.context.userId
                state.commit('getUserid', userid)
            })
        },*/
        getQRCodeContent (state, myliffId){
            //console.log(`====2222:${myliffId}====`)
            liff.init({
                liffId: myliffId
            }).then(()=>{
                //console.log('====22223====')
                liff.scanCode().then((result) => {
                    const stringifiedResult = JSON.stringify(result.value);
                    console.log(`QRCode內容: ${stringifiedResult}`)
                }).catch((err) => {
                    //console.log(`===2222${err}`)
                })
            }).catch((err) => {

            })
        },
        getApi (state, contents) {
            // <回覆訊息>
            setTimeout(() => {
                let keyword = contents.keyword
                let channelId = contents.c
                //alert('chann: ' + contents.c)
                //alert('getApi_userId:' + this.getters.userId)

                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/LIFFCardReply'
                let postData = {
                    "KeyWord": keyword,
                    "ChannelID": channelId,
                    "USID": this.getters.userId
                }
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    console.log("getApi")
                    console.log(res)
                    //alert(res)  //[object object]
                });
            },300);

            // <導至對話框>2s
            setTimeout(function () {
                document.getElementById('auto').click();
            }, 1000);
        },
        // 開啟即自動偵測是否已加入好友
        getAutoclick (state, contents) {
            setTimeout(() => {
                let channelId = contents.c
                let keyword = contents.keyword
                //alert('userID: ' + this.getters.userId)

                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/USIDCheck'
                let postData = {
                    "USID": this.getters.userId,
                    "ChannelID": channelId
                }
                console.log(keyword)
                state.commit('statecontent', postData)
                return axios.post(apiUrl, postData)
                .then((response) => {
                    fetch('https://api-linebiz.eilis-ai.com/app/LIFFCardReply', {
                        body: JSON.stringify({
                            "KeyWord": keyword,
                            "USID": this.getters.userId,
                            "ChannelID": channelId
                        }),
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'content-type': 'application/json'
                        },
                        method: 'POST',
                    })
                    return response
                })
                .then((result) => {
                    //alert(JSON.stringify(result.data));
                    state.UserCheck = result.data //result.data: true or false
                    //alert("state_UserCheck" + state.UserCheck)
                    state.commit('liffAlert', result.data)
                    if (result.data == false) {
                        document.getElementById("auto").click()
                    }
                });
            },1500);
        },
        //完成 取得OAlink
        getBasicid(state, contents) {
            
            let apiUrl = 'https://api-linebiz.eilis-ai.com/app/GetOfficeAccountUrl'
            let postData = {
                "ChannelID": this.getters.channelId
            }
            axios.post(apiUrl, postData)
            
            .then((res)=>{
                //console.log(res.data.Report)
                state.commit('getBasicid',res.data.Report)
                //window.location.href=`${res}`   
            }) 
        },
        // 取得basicID //
        getID (state, contents) {
            setTimeout(() => {
                //alert("re_c:" + contents.c)
                let channelId = contents
                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/GetBasicID'
                let postData = {
                    "ChannelID": channelId
                }
                // console.log(postData)
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    //console.log(res)
                    //alert(JSON.stringify(res))
                    state.commit('getID', res.data.Report)
                });
            },800);
        },
        // 發送推薦好友API, 紀錄推薦人的USID //
        recommend (state, contents) {
            setTimeout(() => {
                //alert("recommend_c:" + contents.c)
                let channelId = contents.c
                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/RecommendByLIFF'
                let postData = {
                    "ChannelID": channelId,
                    "USID": this.getters.userId
                }
                // console.log(postData)
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    // console.log(res)
                    //alert("recommend:\n"+JSON.stringify(res))  //[object object]
                });
            },1000);

            // setTimeout(function () {
            //    location.window.href="https://google.com"
            // }, 2000);
        },
        // 接收推薦好友API, 紀錄推薦人的USID與被推薦人的ID //
        rec_recommend(state, contents) {
            setTimeout(() => {
                let channelId = contents.c
                let recommenderId = this.getters.recUserID
                //alert('rec: ' + recommenderId + " c:" + channelId)
                //alert('getApi_userId:' + this.getters.userId)

                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/ReceiveRecommendByLIFF'
                let postData = {
                    "RecommenderUSID": recommenderId,
                    "ChannelID": channelId.split('&rec=')[0],
                    "USID": this.getters.userId
                }
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    //window.alert(JSON.stringify(res))
                    //alert(res)  //[object object]
                    console.log(postData)
                    document.getElementById('auto').click();
                });
            },1000);

            // setTimeout(function () {
            //     document.getElementById('auto').click();
            // }, 1500);
        },
        // 成功推薦人數查詢 //
        numOfshare (state, contents) {
            setTimeout(() => {
                let channelId = contents.c
                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/LIFFNumberOfShare'
                let postData = {
                    "ChannelID": channelId,
                    "RecommenderUSID": this.getters.userId //"Ubba5047518c5dac3a4ee2e90ed7a1e09"
                }
                //alert("Rec_channelId:" + channelId + "userid:" + this.getters.userId)
                // console.log(postData)
                // state.commit('getChannelId',channelId)
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    // console.log(res)
                    //console.log(res.data.ShareNumber)
                    state.commit('numOfshare', res.data.ShareNumber)
                    //alert("numOfshare:\n"+JSON.stringify(res))  //[object object]
                });
            },1000);
        }
    },
    getters: {
        keyword(state) {
            //alert("getter"+state.keyword)
            return state.keyword
        },
        userId(state) {
            return state.userId
        },
        recUserID(state) {
            return state.recUserID
        },
        Uid(state) {
            return state.Uid
        },
        _liffId(state) {
            return state._liffId
        },
        ShareDescription(state){
            return state.ShareDescription
        },
        point(state) {
            if(state.share != 0) {
                state.point = state.share * 10
            }
            return state.point
        },
        level(state) {
            if(state.point != 0) {
                state.level = Math.floor(state.point / 10)
            }
            return state.level
        },
        share(state) {
            return state.share
        },
        displayname(state) {
            return state.displayname
        },
        picture(state) {
            return state.picture
        },
        share(state) {
            return state.share
        },
        channelId(state) {
            return state.channelId
        },
        bgColor(state) {
            return state.bgcolor
        },
        basicid(state) {
            return state.basicid
        }
    },
    mutations: {
        bgColor(state, color) {
            state.bgcolor = color
        },
        getkeyword(state, key) {
            state.keyword = key
            //alert("get:"+state.keyword)
        },
        getUserPro(state, user) {
            state.displayname = user.displayName
            state.picture = user.picture
            state.userId = user.userid
            //alert("getUserPro_userId" + state.userId)
        },
        getBasicid(state, basicid){
            state.basicid = basicid
        },
        /*getUserid(state, user) {
            state.userId = user
            //alert("mu_userid:" + state.userId)
        },*/
        numOfshare(state, shareNumber){
            state.share = shareNumber
        },
        statecontent(state, postData) {
            state.channelId = postData.ChannelID
            //alert(state.channelId)
        },
        liffAlert(state, check) {
            state.UserCheck = check
            //alert("mu_usercheck:" + check)
        },
        getID(state, contents) {
            state.Uid = contents
            //alert("id:" + state.Uid)
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js